export const CREATE_NORMAL_ONBOARDING = 'normal_onborading'
export const GET_BY_PROJECT_ID = 'get_by_project_id'